<template>
    <div class="firm-clues-info">
        <div class="title-box">
            <div class="title-box-left">
                <div class="title">即时线索</div>
                <span class="tip" ref="mainTitleTip">
                    <!-- eslint-disable -->
                    <img
                        class="icon"
                        src="../../../assets/img/law/question.svg"
                    />
                </span>
                <veui-popover
                    target="mainTitleTip"
                >
                    即时线索是面向律临会员提供的专属权益，非会员需开通会员后享受。</br>
                    在认领公海中认领与您匹配的线索，线索质量高、时效性高。</br>
                </veui-popover>
                <span class="yellow-icon">优质线索</span>
                <span class="yellow-icon">高时效性</span>
            </div>
            <div class="vip-set" @click="goVipSet">权益授权管理</div>
        </div>
        <div class="claimed-box">
            <div class="claimed-in-month">
                <!-- eslint-disable -->
                <div class="title">
                    本月线索额度
                    <img
                        ref="tip"
                        class="icon"
                        src="../../../assets/img/law/question.svg"
                        alt=""
                    />
                    <div class="number">
                        {{ receivedInfo.clue_quota || 0 }}
                    </div>
                    <veui-popover target="tip" position="bottom-center">
                        <span class="help-text"
                            >线索额度每月1号更新，当月线索剩余余量次月清空不递延累加，请于当月内尽快认领，避免损失，您可通过「权益授权设置」授权指定成员消耗线索</span
                        >
                    </veui-popover>
                </div>
                <!-- eslint-enable -->
            </div>
            <div class="line"></div>
            <div class="claimed-in-month">
                <div class="title">
                    本月剩余线索数
                    <img
                        ref="tip-sy"
                        class="icon"
                        src="../../../assets/img/law/question.svg"
                        alt=""
                    />
                    <div class="number">
                        <span class="info-msg-num-value">
                            {{ receivedInfo.all_month_remain }}
                        </span>
                    </div>
                    <veui-popover target="tip-sy" position="bottom-center">
                        <span
                            class="help-text"
                        >
                            当月剩余线索数为当月线索额度减去已经被认领后的数量
                        </span>
                    </veui-popover>
                </div>
            </div>
            <div class="line"></div>
            <div class="claimed-in-month">
                <div class="title">
                    累计认领线索数
                    <img
                        ref="tip-lj"
                        class="icon"
                        src="../../../assets/img/law/question.svg"
                        alt=""
                    />
                    <div class="number">
                        <span class="info-msg-num-value">
                            {{ receivedInfo.all_received }}
                        </span>
                    </div>
                    <veui-popover target="tip-lj" position="bottom-center">
                        <span
                            class="help-text"
                        >
                            所有成员累计线索认领数
                        </span>
                    </veui-popover>
                </div>
            </div>
            <div v-if="localStarInfo && localStarInfo.length" class="line"></div>
            <!-- 开通了本地之星才展示 -->
            <div
                v-if="localStarInfo && localStarInfo.length"
                class="claimed-in-month"
            >
                <local-star-box :local-star-info="localStarInfo"/>
            </div>
        </div>
        <div v-if="enableClue" class="clue-box">
            <div class="tip-icon"></div>
            <div class="tip-text">您已获得律所授权，可以进行线索认领</div>
        </div>
    </div>
</template>
<script>
import 'veui-theme-dls-icons';
import {Popover} from 'veui';
import localStarBox from '@/components/localStarBox.vue';
/**
 * @file firmCluesInfo
 * @author zhengyixin
 */

export default {
    components: {
        'veui-popover': Popover,
        'local-star-box': localStarBox
    },
    props: {
        receivedInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        accountInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        enableClue: {
            type: Number,
            default: 0
        },
        // 本地之星数据
        localStarInfo: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            time: 0,
            currentTime: 0
        };
    },
    methods: {
        goVipSet() {
            this.$router.push({name: 'vipSet'});
        }
    }
};
</script>
<style lang="stylus" scoped>
.firm-clues-info {
    background: #fff;
    border-radius: 8px;
    padding: 30px 24px 24px;
    box-sizing: border-box;
    box-shadow: 0px 6px 14px 0px rgba(227, 233, 237, 0.35);
    .title-box {
        display: flex;
        justify-content: space-between;
        .title-box-left {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #333;
            line-height: 20px;
            font-weight: 600;
        }
        .tip {
            display: inline-block;
            height: 14px;
            width: 14px;
            margin-left: 6px;
            margin-right: 10px;
            cursor: pointer;
            img {
                height: 100%;
                width: 100%;
            }
        }
        .yellow-icon {
            display: block;
            width: 60px;
            height: 16px;
            margin-right: 6px;
            border-radius: 8px;
            background-image: linear-gradient(90deg, #FFE99E 1%, #FFDC68 100%);
            font-family: PingFangSC-Regular;
            color: #a54300;
            font-size: 10px;
            line-height: 16px;
            text-align: center;
        }
        .vip-set {
            font-size: 16px;
            color: #3e4cff;
            position: relative;
            padding-right: 15px;
            cursor: pointer;
            &::after {
                content: '';
                position: absolute;
                width: 18px;
                height: 16px;
                background: url('https://lvlin-base.cdn.bcebos.com/bend/icon-down.png') no-repeat;
                background-size: cover;
                top: 4px;
                margin-left: 6px;
                transform: rotate(270deg);
            }
        }
    }
    .claimed-box {
        display: flex;
        margin-top: 24px;
        background: radial-gradient(185.91% 186.83% at 34% -11.87%,
            rgba(231, 239, 255, 0.4) 0%, rgba(224, 230, 247, 0.4) 100%);
        justify-content: space-between;
        align-items: center;
        .line {
            width: 1px;
            height: 48px;
            background: rgba(51, 51, 51, 0.09);
        }
        .claimed-in-month {
            min-height: 97px;
            border-radius: 8px;
            padding: 24px 24px 22px;
            .title {
                font-family: PingFangSC-Regular;
                font-size: 13px;
                color: #333;
                line-height: 14px;
                .icon {
                    width: 14px;
                    height: 14px;
                    margin-left: 3px;
                    vertical-align: bottom;
                    cursor: pointer;
                }
            }
            .number {
                font-family: HelveticaNeue-Bold;
                font-size: 28px;
                color: #282c33;
                line-height: 28px;
                font-weight: 700;
                margin-top: 8px;
            }
        }
    }
    .clue-box {
        display: flex;
        background: #e5f1ff;
        padding: 15px 24px;
        align-items: center;
        margin-top: 33px;
        .tip-icon {
            width: 20px;
            height: 20px;
            background: url('https://lvlin-base.cdn.bcebos.com/bend/icon-warning.png') no-repeat center center / 100% 100%; // lvlin-base.cdn.bcebos.com/bend/icon-warning.png) no-repeat center center / 100% 100%;
            margin-right: 5px;
            flex-shrink: 0;
            transform: rotate(180deg);
        }
        .tip-text {
            font-size: 14px;
            color: #333;
        }
    }
}
</style>
